import Bio from './Bio';
export default Bio;